export default "__VITE_ASSET__ZYPQD50G__"